interface IParams {
  value: number | null
  baseline: number | null
}

/** Percent change of `value` against `baseline` — the delta shown next to plan / expected
 *  exit / YTD actuals cells. A missing or zero baseline is treated as "nothing to grow
 *  from": a positive `value` reads as a full `100` (new), and `0`/missing `value` reads as
 *  `0` (flat) rather than `null`, since the cockpit does have a concrete value to show — it
 *  just has no prior baseline to size it against. */
export const calculateCockpitGrowth = ({ value, baseline }: IParams): number | null => {
  if (value === null) {
    return null
  }

  if (baseline === null || baseline === 0) {
    return value === 0 ? 0 : 100
  }

  return ((value - baseline) / baseline) * 100
}

export const calculateCockpitSobGrowth = ({ value, baseline }: IParams): number | null => {
  if (value === null) {
    return null
  }

  if (baseline === null || baseline === 0) {
    return value
  }

  return value - baseline
}
